import Wolfpic from "./assets/hidden.gif";
import Wolf from "./assets/hidden.gif";

import { Box, Button, Flex, Input, Text, Image, Stack } from '@chakra-ui/react';

const Faq = ({ accounts, setAccounts }) => {

    return (
        <Flex justify='center' align='center' height='auto' >
            <Box
                width={['90vw', '80vw', '75vw', '60vw']}
                height='auto'
                backgroundColor='#83EDF3'
                borderRadius='15px'
                boxShadow='0px 7px 7px 5px #0F0F0F'
                color='black'
                fontFamily='inherit'
                fontSize='1.5vw'
                padding='10px'
                margin='50px 15px'
                backgroundcolor='transparent'
            >
                <div>
                    <Stack direction='row' align='top'>
                        <Image boxSize={['25vw', '20vw', '15vw', '10vw']} borderRadius='200px' margin='5px 0px' src={Wolf} />
                        <Stack direction='column'>
                            <Text
                                fontSize={['4.5vw', '4vw', '3vw', '2vw']}
                                fontWeight='bold'
                                letterSpacing='-5.5%'
                                fontFamily='inherit'
                                margin='5px 0px'
                                textAlign='left'
                            >
                                What is it?
                            </Text>
                            <Text
                                fontSize={['4.5vw', '4vw', '3vw', '2vw']}
                                fontStyle='normal'
                                letterSpacing='-5.5%'
                                fontFamily='inherit'
                                margin='5px 0px'
                                textAlign='left'
                            >
                                Wacky Wolf Friends is an NFT collection of Doodle style Wolves generated from 111 hand 
                                drawn traits. 
                            
                            </Text>
                        </Stack>
                    </Stack>
                    <br />
                    <Stack direction='row' align='top'>
                        <Stack direction='column'>
                            <Text
                                fontSize={['4.5vw', '4vw', '3vw', '2vw']}
                                fontWeight='bold'
                                letterSpacing='-5.5%'
                                fontFamily='inherit'
                                margin='5px 0px'
                                textAlign='left'
                            >
                               What’s the goal?
                            </Text>
                            <Text
                                fontSize={['4.5vw', '4vw', '3vw', '2vw']}
                                fontStyle='normal'
                                letterSpacing='-5.5%'
                                fontFamily='inherit'
                                margin='5px 0px'
                                textAlign='left'
                            >
                                Our project aims to build an engaged community that enjoys collecting great artwork and 
                                aiding in conservation efforts throughout the world. During the duration of the project, 
                                our team and community aims to provide a portion of our earnings to various likeminded 
                                organizations around the globe.
                            
                            </Text>
                        </Stack>
                        <Image boxSize={['25vw', '20vw', '15vw', '10vw']} borderRadius='200px' margin='5px 0px' src={Wolf} />
                    </Stack>
                </div>
            </Box>
        </Flex>
    )

};

export default Faq;